import { Component, computed, input, signal } from '@angular/core'
import { MetricModel } from 'src/app/shared/models/metric.model'
import { AppStateService } from 'src/app/core/services/app-state.service'
import { Layers } from 'src/app/shared/layers-config/layers'
import { RcsMetrics, getMetricFromMap } from '../../enums/rcs-metrics.enum'
import { Observable, Subject, takeUntil } from 'rxjs'
import { ProviderInfo } from 'src/app/obstacle/model/provider-info.model'

@Component({
  selector: 'app-rc-legend',
  templateUrl: './rc-legend.component.html',
  standalone: false,
})
export class RcLegendComponent {
  private cleanUp$ = new Subject<void>()
  public metrics: string | undefined
  public isRoadMetricLayerVisible = signal(false)
  public isWeatherPredictionLayerVisible = signal(false)
  public isVehicleDataRainLayerVisible = signal(false)
  public isVehicleDataSlipperyLayerVisible = signal(false)
  public isLayerSelectionVisible = false

  public roadMetric = signal<MetricModel | undefined>(undefined)
  public weatherPreditionMetric = signal<MetricModel | undefined>(undefined)
  public vehicleDataMetric = signal<MetricModel | undefined>(undefined)
  public providerInfo$ = input.required<Observable<ProviderInfo>>()

  public isOneVehicleDataLayerVisible = computed(
    () => this.isVehicleDataRainLayerVisible() || this.isVehicleDataSlipperyLayerVisible(),
  )

  public hasAnyLegendVisible = computed(
    () =>
      this.isRoadMetricLayerVisible() ||
      this.isWeatherPredictionLayerVisible() ||
      this.isOneVehicleDataLayerVisible(),
  )

  constructor(private appState: AppStateService) {
    this.evaluateQueryParameters()

    this.appState.stateChanged.pipe(takeUntil(this.cleanUp$)).subscribe(() => {
      this.evaluateQueryParameters()
    })
  }
  ngOnDestroy(): void {
    this.cleanUp$.next()
    this.cleanUp$.complete()
  }

  evaluateQueryParameters() {
    const layers = this.appState.getState().layers

    this.isWeatherPredictionLayerVisible.set(!!layers?.includes(Layers.WeatherPrediction.name))
    this.isRoadMetricLayerVisible.set(!!layers?.includes(Layers.RoadSegment.name))
    this.isVehicleDataRainLayerVisible.set(!!layers?.includes(Layers.Provider4HeavyRain.name))
    this.isVehicleDataSlipperyLayerVisible.set(!!layers?.includes(Layers.Provider4Slippery.name))

    const roadMetricKeys = this.appState.selectMetrics(Layers.RoadSegment.name)
    if (roadMetricKeys && roadMetricKeys.length > 0) {
      this.roadMetric.set(getMetricFromMap(roadMetricKeys[0]))
    } else {
      this.roadMetric.set(undefined)
    }

    const weatherPredictionKeys = this.appState.selectMetrics(Layers.WeatherPrediction.name)
    if (weatherPredictionKeys && weatherPredictionKeys.length > 0) {
      this.weatherPreditionMetric.set(getMetricFromMap(weatherPredictionKeys[0]))
    } else {
      this.weatherPreditionMetric.set(undefined)
    }

    this.vehicleDataMetric.set(getMetricFromMap(RcsMetrics.VehicleData_HeavyRain))
  }
}
